
import { Container, Row, Col, Nav } from "react-bootstrap";
import blogImg from "../assets/img/blogImage1.jpeg";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const ChoosingRightDomainName = () => {
 
  return (
    <section className="career" id="career">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h1>How To Choose The <span className='quoteHeader'>Right Domain Name</span> For Your Business</h1>
                <h4>TotleSoft Blog</h4><br />
                  <p>
                  More than 60% of businesses make these mistakes when deciding on a domain name; don’t be one of them.<br /><br />
                  Here are five common mistakes to avoid when selecting a domain name for your website, with numbers four and five being the most common.
                  </p>
                  <br />
                  <h3>1. Choose A Short Domain Name</h3>
                  <p>
                  Choosing an overly long domain name is not a good idea when choosing a domain name.It is always best to keep your domain name short and sweet. The shorter it is, the better and more memorable it is.
                  </p>
                  <h3>2. Choose An Easy To Type Domain Name</h3>
                  <p>
                  Choosing a difficult-to-type domain is another mistake to avoid in this regard. Please change your domain if it requires more than one explanation to spell/type. You want to relieve stress, not cause it.
                  </p>
                  <h3>3. Choose An Easy-To-Pronounce Domain Name</h3>
                  <p>
                  Choosing a difficult-to-pronounce domain should also be avoided. Do not choose a domain that is difficult to convert to text using audio. Pick a name that is simple to say and spell. Hyphens and numbers are also difficult to transcribe, so avoid them.
                  </p>
                  <h3>4. Think Long-Term</h3>
                  <p>
                  Thinking short-term in domain name choice should not be considered. For many years, your domain name will be the most important aspect that defines your business and brand.<br /><br />
                  Changing the domain name in the future will cost money, branding, and even SEO ranking, and it will be a major hassle.<br /><br />
                  The domain name should always be related to your company. If there’s a chance you’ll extend your business service in the future, it’s a better idea to reevaluate your domain name.
                  </p>
                  <h3>5. Do Not Think Generic</h3>
                  <p>
                  Simply put, choose a generic name. Remember that you are first and foremost a brand. Instead of a generic moniker, go with a brandable one( like Google and Yahoo did). Through a memorable name, sell pleasurable emotions and experiences.<br /><br />
                  Keywords have always enhanced SEO; but, if you try to incorporate unflattering keywords into your domain, it will appear generic. It is generally advisable to employ the keywords just at the start of the domain. This is where it will have the greatest impact on your rankings. It is suggested that you use keyword tools such as SEMrush. <br /><br />
                  PS: Make sure the domain name does not contain any other brands or trademarks. If you violate someone’s copyright, you may face legal consequences. <br /><br />
                  It takes time and research to find the perfect domain name for a website, but it will be well worth it. I hope this helped.
                  </p>
                 <button>You may also like <ArrowRightCircle size={25} /></button>
                 <Nav.Link href="/blog"><h3>* 5 Benefits of Hiring Professional Printing Services</h3></Nav.Link><br />
                 <Nav.Link href="/five-advantages-of-using-a-professional-designer-for-your-business"><h3>* Five Advantages Of Using A Professional Designer For Your Business</h3></Nav.Link><br />
                 <Nav.Link href="/core-branding-proposal-tips"><h3>* Core Branding Proposal Tips</h3></Nav.Link>
                 </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={blogImg} alt="Header Img"/>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
